<script>
import { Line } from 'vue-chartjs'
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities'

function randomBetween(min, max) { 
  // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}


export default {
  extends: Line,
  props: ['height', 'width', 'previousValue', 'currentValue', 'type'],


  mounted () {

    let trendDataSet = {
      label: '',
      borderColor: '#000',
      fill: false,
      data: []  
    }

    // avoid divide-by-zero errors
    if(this.previousValue == 0) {
      this.previousValue = 1
    }

    var diffPct = (this.currentValue - this.previousValue) / this.previousValue * 100
    var minSubtract = this.currentValue > this.previousValue ? this.previousValue * .05 : this.currentValue * .05
    
    if(this.currentValue > this.previousValue) {
      // positive trend.  green positive line
      var diff = this.currentValue - this.previousValue

      trendDataSet.borderColor = '#4dbd74'  // success
      trendDataSet.data = [
        this.previousValue - (diff * .12),
        this.previousValue - (diff * .15),
        this.previousValue, 

        this.previousValue + randomBetween((diff * .10), (diff * .40)),
        this.previousValue + (diff * .5),
        this.previousValue + randomBetween((diff * .60), (diff * .90)),

        this.currentValue,
        this.currentValue + (diff * .15),
        this.currentValue + (diff * .12),
      ]

    } else if(this.currentValue < this.previousValue) {
      // negative trend.  red negative line
      var diff = this.previousValue - this.currentValue

      trendDataSet.borderColor = '#f86c6b'  // danger
      trendDataSet.data = [
        this.previousValue + (diff * .12),
        this.previousValue + (diff * .15),
        this.previousValue, 

        this.previousValue - randomBetween((diff * .10), (diff * .40)),
        this.previousValue - (diff * .5),
        this.previousValue - randomBetween((diff * .60), (diff * .90)),

        this.currentValue,
        this.currentValue - (diff * .15),
        this.currentValue - (diff * .12),
      ]

    } else {
      // no change.  flat grey line
      trendDataSet.borderColor = '#8f9ba6'  // Gray 500
      trendDataSet.data = [50, 50]
    }

    // console.log(trendDataSet)
    if(this.type == 'straight') {
      trendDataSet.data.pop()
      trendDataSet.data.splice(3, 3)
      trendDataSet.data.splice(0, 1)

    }

    this.renderChart(
      {
        labels: new Array(trendDataSet.data.length),
        datasets: [trendDataSet]
      },
      {
        layout: {
          padding: {
            top: 5
          }
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 0, 
            hoverRadius: 0
          }
        },
        tooltips: {
          enabled: true
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, trendDataSet.data) - 5,
                max: Math.max.apply(Math, trendDataSet.data) + 10
              }
            }
          ]
        },
        // scales: {
        //   xAxes: [{
        //     display: false
        //   }],
        //   yAxes: [{
        //     display: false
        //   }]
        // }
      }
    )
  }
}
</script>
